<template>
  <div>
    <validation-observer ref="formAddJournalEntry" #default="{ invalid }">
      <b-form @submit.prevent="submitJournalEntry"></b-form>
    <b-card>
      <b-form>
        <b-row>
          <!-- {{ journalEntryId }} -->
          <b-col md="6" cols="6" class="my-md-1">
            <validation-provider rules="required" #default="{ errors }" name="Transaction Date"
            vid="Transaction Date">
            <b-form-group label="Transaction Date" label-for="transactionDateInput">
              <b-form-datepicker id="transactionDateInput" v-model="journal.date"></b-form-datepicker>
            </b-form-group>
          </validation-provider>
          </b-col>
          <b-col md="6" cols="6" class="my-md-1">
            <validation-provider rules="required" #default="{ errors }" name="Reference" vid="Reference">
              <b-form-group label="Reference" label-for="referenceInput">
              <b-form-input id="referenceInput" type="text" v-model="journal.refID" ></b-form-input>
            </b-form-group>
          </validation-provider>
          </b-col>
        </b-row>
      </b-form>
    </b-card>

    <b-card class="mt-3">
      <div class="float-right my-1">
        <b-button variant="primary" @click="addRow">Add Row</b-button>
      </div>

      <b-col v-if="loading" cols="12" class="text-center my-2">
        <b-spinner variant="success" label="Spinning" block style="width: 3rem; height: 3rem"></b-spinner>
      </b-col>
      <b-table v-if="!loading" responsive :items="journal.journalEntryLines" :fields="tableFields" striped>
        <template v-slot:cell(account)="row">
          <validation-provider rules="required" #default="{ errors }" name="Account" :vid="`account_${row.index}`">
            <b-form-select v-model="row.item.accountID" :options="optionsAccount" required
              :state="errors.length > 0 ? false : null"></b-form-select>
            <small v-if="errors.length" class="text-danger text-end">{{
              errors[0]
            }}</small>
          </validation-provider>
        </template>
        <template v-slot:cell(debit)="row">
          <validation-provider rules="required" #default="{ errors }" name="Debit" :vid="`debit_${row.index}`">
            <b-form-input type="text" v-model="row.item.debit" :disabled="row.item.credit !== 0" required
              :state="errors.length > 0 ? false : null"></b-form-input>
            <small v-if="errors.length" class="text-danger text-end">{{
              errors[0]
            }}</small>
          </validation-provider>
        </template>
        <template v-slot:cell(credit)="row">
          <validation-provider rules="required" #default="{ errors }" name="Credit" :vid="`credit_${row.index}`">
            <b-form-input type="text" v-model="row.item.credit" :disabled="row.item.debit !== 0" required
              :state="errors.length > 0 ? false : null"></b-form-input>
            <small v-if="errors.length" class="text-danger text-end">{{
              errors[0]
            }}</small>
          </validation-provider>
        </template>
        <template v-slot:cell(contact)="row">
          <b-form-select v-model="row.item.contact" :options="optionsContact"></b-form-select>
        </template>
        <template v-slot:cell(description)="row">
          <validation-provider rules="required" #default="{ errors }" name="Description" :vid="`description_${row.index}`">
            <b-form-textarea v-model="row.item.description" rows="3" required
              :state="errors.length > 0 ? false : null"></b-form-textarea>
            <small v-if="errors.length" class="text-danger text-end">{{
              errors[0]
            }}</small>
          </validation-provider>
        </template>
        <template v-slot:cell(amount)="row">
          <span>{{ getAmount(row) }}</span>
        </template>
        <template v-slot:cell(Actions)="data">
          <a @click.prevent="deleteEntry(data.index)" href="#">
            <feather-icon icon="TrashIcon" class="text-body align-middle" />
          </a>
        </template>
      </b-table>

      <!-- Total Debit and Total Credit -->
      <b-row v-if="!loading">
        <b-col md="12" class="d-flex justify-content-end">
          <div class="py-1 px-2 d-flex">
            <h5>Total Debit:</h5>
            <span class="ml-5">{{ getTotalDebit }}</span>
          </div>
        </b-col>
        <b-col md="12" class="d-flex justify-content-end">
          <div class="py-1 px-2 d-flex">
            <h5>Total Credit:</h5>
            <span class="ml-5">{{ getTotalCredit }}</span>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-col md="12" class="d-flex justify-content-end">
      <b-button variant="primary" type="button" :disabled="isSubmitting"
        @click="submitJournalEntry()">Save</b-button>
    </b-col>
  </b-form>
</validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BTable,
  BButton,
  BFormInput,
  BFormTextarea,
  BDropdown,
  BDropdownItem,
  BFormGroup,
  BFormSelect,
  BCard,
  BFormDatepicker,
  BForm,
  VBTooltip,
  BSpinner,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import "bootstrap-vue/dist/bootstrap-vue.css";
import SearchBar from "@/components/search-component/SearchBar.vue";
import { customError, customLoader, customSwal } from "@/libs/customFn";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BButton,
    BFormInput,
    BFormTextarea,
    BDropdown,
    BDropdownItem,
    BFormGroup,
    BFormSelect,
    BCard,
    BFormDatepicker,
    BForm,
    BSpinner,
    SearchBar,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      id: this.$route.params.id,
      date: "",
      journal: {},
      description: "",
      items: [],
      showSpinner: true,
      token: localStorage.getItem("accessToken"),
      tableFields: [
        { key: "account", label: "ACCOUNT", sortable: false },
        { key: "debit", label: "DEBIT", sortable: false },
        { key: "credit", label: "CREDIT", sortable: false },
        { key: "contact", label: "CONTACT", sortable: false },
        { key: "description", label: "DESCRIPTION", sortable: false },
        { key: "amount", label: "AMOUNT", sortable: false },
        { key: "Actions", label: "", sortable: false },
      ],
      tableData: [
        { account: "", debit: 0, credit: 0, contact: null, description: "", amount: "" },
      ],
      loading: true, // Add loading state
      journalentrylines: [],
      isSubmitting: false,
    };
  },
  computed: {
    getTotalDebit() {
      return this.journal.journalEntryLines ?
        this.journal.journalEntryLines
          .reduce((total, row) => {
            const debit = parseFloat(row.debit);
            return !isNaN(debit) ? total + debit : total;
          }, 0)
          .toFixed(2)
        : 0;
    },
    getTotalCredit() {
      return this.journal.journalEntryLines ?
        this.journal.journalEntryLines
          .reduce((total, row) => {
            const credit = parseFloat(row.credit);
            return !isNaN(credit) ? total + credit : total;
          }, 0)
          .toFixed(2)
        : 0;
    },
    optionsContact() {
      return this.CustomerList.map((v) => ({
        value: v.id,
        text: `${v.otherName ?? v.companyName} ${v.surname ?? ""}`,
      }));
    },

    optionsAccount() {
      return this.chartofaccount.filter((v) => v.name !== "Accounts Receivable" && v.name !== "Accounts Payable" && v.name !== "Sales" && v.name !== "Sales Tax"&& v.name !== "Purchase Tax").map((v) => ({
        value: v.id,
        text: v.name,
      }));
    },
    ...mapGetters("journalentryModule", {
      journalentry: "journalentry",
      journalEntryId: "id",
      jeLoading: "loading",
    }),
    ...mapGetters("customerModule", {
      CustomerList: "customers",
      custId: "custId",
    }),
    ...mapGetters("chartofaccountModule", {
      chartofaccount: "chartofaccount",
      coaloading: "loading",
    }),
  },
  methods: {
    ...mapActions("journalentryModule", ["getJournalEntryListAction", "getJournalEntryIDAction", "updateJournalEntryAction"]),
    ...mapActions("customerModule", [
      "getCustomersListAction",
      "getCustomersByIDAction",
    ]),
    ...mapActions("chartofaccountModule", [
      "getChartOfAccountListAction",
      "addChartOfAccountAction, updateChartOfAccountAction, getChartOfAccountIDAction",
    ]),
    deleteEntry(index) {
      this.journal.journalEntryLines.splice(index, 1);
    },
    formatDate(date) {
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(date).toLocaleDateString("en-US", options);
    },
    addRow() {
      this.journal.journalEntryLines.push({
        account: "",
        debit: 0,
        credit: 0,
        description: "",
        amount: 0,
        contactID: null,
      });
    },
    getAmount(row) {
      return row.item && (row.item.debit || row.item.credit)
        ? row.item.debit || row.item.credit
        : "0.00";
    },
    async fetchJournalEntry() {
      try {
        await this.getJournalEntryIDAction(this.id);
        this.journal = this.journalEntryId;
        if (this.journal.journalEntryLines) this.journal.journalEntryLines.sort((a, b) => a.lineID - b.lineID);
      } catch (error) {
        console.error("Error fetching journal entry lines:", error);
      }
    },
    async submitJournalEntry() {
      const isValid = await this.$refs.formAddJournalEntry.validate();
      if (isValid) {
        let loader = customLoader("Please wait while the details are loading...");
        try {
          this.isSubmitting = true;
          
          this.journal.journalEntryLines.forEach((line, index) => {
            line.journalEntryId = this.id;
            line.lineID = index;
            line.description = line.description;
            line.debit = parseFloat(line.debit) || 0;
            line.credit = parseFloat(line.credit) || 0;
            line.entryType = parseFloat(line.debit) === 0 ? "Credit" : "Debit";
            line.accountID = line.accountID;
            line.contactID = line.contact;
            line.accountType = 1;
            line.paid = 0;
          });

          const response = await this.updateJournalEntryAction(this.journal);
          if(response.success){
            customSwal("You have successfully updated a journal entry!");
          }else{
            customError(response.message);
          }
          loader.close();
          this.$router.push({ name: 'journalentry-list' });
        } catch (error) {
          loader.close();
          customError(error.response.data)
          console.error("Error adding journal entry:", error);
        } finally {
          this.isSubmitting = false;
        }
      }
    },
    async loadInitialData() {
      this.loading = true;
      try {
        await this.getCustomersListAction();
        await this.getChartOfAccountListAction();
      } catch (error) {
        console.error("Error fetching initial data:", error);
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    this.loading = true;
    try {
      await this.getChartOfAccountListAction();
      await this.fetchJournalEntry();
      await this.getCustomersListAction();
    } catch (error) {
      console.error("Error fetching initial data:", error);
    } finally {
      this.loading = false;
    }
  },
};
</script>
